import { render, staticRenderFns } from "./bind.vue?vue&type=template&id=ce4eddfc&scoped=true"
import script from "./bind.vue?vue&type=script&lang=js"
export * from "./bind.vue?vue&type=script&lang=js"
import style0 from "./bind.vue?vue&type=style&index=0&id=ce4eddfc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4eddfc",
  null
  
)

export default component.exports